let privacy="<div><h3>隐私协定</h3></div>";

export { privacy };